<template>
  <div>
    <el-header ref="header" class="header" style="height: auto;margin-bottom: 10px">
      <el-form :inline="true" :model="searchForm" ref="searchFormRef" class="demo-form-inline">
        <div id="searchBox">
          <el-form-item label="" prop="xhname">
            <el-input placeholder="请输入型号" v-model="searchForm.xhname" @keydown.native.enter="handleSearchBtn"/>
          </el-form-item>
          <el-form-item label="" prop="company">
            <el-input placeholder="请输入公司名" v-model="searchForm.company" @keydown.native.enter="handleSearchBtn"/>
          </el-form-item>
          <el-form-item label="" prop="orderid">
            <el-input placeholder="请输入合同编号" v-model="searchForm.orderid" @keydown.native.enter="handleSearchBtn"/>
          </el-form-item>
          <el-form-item label="" prop="gongyingshang">
            <el-input placeholder="请输入采购渠道" v-model="searchForm.gongyingshang"@keydown.native.enter="handleSearchBtn" />
          </el-form-item>
          <el-form-item label="" prop="sfkp">
            <el-select placeholder="是否开票" clearable v-model="searchForm.sfkp" @keydown.native.enter="handleSearchBtn">
              <el-option v-for="(item,index) in isInvoicing" :key="index" :value="item.value" :label="item.label">
                {{ item.label }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="sfsp">
            <el-select placeholder="收票状态" clearable v-model="searchForm.sfsp" @keydown.native.enter="handleSearchBtn">
              <el-option v-for="(item,index) in receiptStatus" :key="index" :value="item.value" :label="item.label">
                {{ item.label }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="ow_type">
            <el-select placeholder="出库状态" clearable v-model="searchForm.ow_type" @keydown.native.enter="handleSearchBtn">
              <el-option v-for="(item,index) in ckTypeStatus" :key="index" :value="item.value" :label="item.label">
                {{ item.label }}
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="text" style="margin-left:10px" id="closeSearchBtn" @click="closeSearch">
            {{ word }}
            <i :class="showAll ? 'el-icon-arrow-up ': 'el-icon-arrow-down'"></i>
          </el-button>
          <el-button type="primary" size="small" @click="handleSearchBtn" icon="el-icon-search">搜索
          </el-button>
          <el-button size="small" @click="handleResetBtn" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <div class="custom-table">
      <el-button v-waves :loading="exportLoading" class="el-icon-download" type="success"
                 size="small" @click="handleExport">导出Excel
      </el-button>
      <el-button type="primary" @click="toggleExpand" size="small">
        {{ isExpanded ? '收起' : '展开' }}
      </el-button>
      <el-table border fit highlight-current-row row-key="id" :data="list"
                class="customer-table" ref="tableRef">
        <el-table-column type="expand">
          <template #default="{ row }">
            <Expand :data="row.childdata" @updateExpand="handleUpdateExpand" @deleteRow="handleDeleteRow"
                    :parentId="row.id" />
          </template>
        </el-table-column>
        <el-table-column label="ID" prop="id"></el-table-column>
        <el-table-column label="所属公司" prop="company" width="300"></el-table-column>
        <el-table-column label="合同编号" prop="orderid" width="140"></el-table-column>
        <el-table-column label="型号" prop="xhname" width="200"></el-table-column>
        <el-table-column label="品牌" prop="source" width="200"></el-table-column>
        <el-table-column label="数量" prop="num"></el-table-column>
        <el-table-column label="单价" prop="price"></el-table-column>
        <el-table-column label="总价" prop="zprice"></el-table-column>
        <el-table-column label="出库状态" prop="ck_type">
          <template slot-scope="scope">
            <el-button type="text" :style="scope.row.ck_type == 'T' ? 'color: green':'color:red'"
                       :icon="scope.row.ck_type == 'T' ?'el-icon-success':'el-icon-error'"
                       v-if="scope.row.ck_type =='T' || scope.row.ck_type == 'F'" style="font-size: 20px" />
            <span v-else>{{ scope.row.ck_type }}</span>
          </template>
        </el-table-column>
        <el-table-column label="成本价" prop="cgzprice"></el-table-column>
        <el-table-column label="操作" width="200" v-if="isShowOperationBtn">
          <template v-slot="scope">
            <el-button type="primary" size="small" @click="handleOutbound(scope.row.xhname,scope.row.id,scope.row.num)"
                       class="el-icon-position"
            >
              出库
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
                     :current-page="selectPage.pageNum" :page-sizes="[20, 50, 100, 200]"
                     :page-size="selectPage.pageSize"
                     background
                     layout="total, sizes, prev, pager, next, jumper" :total="allNum"
                     style="margin-top: 14px;margin-bottom:14px"
      >
      </el-pagination>
    </div>
    <Outbound :dialog="outboundDialog" @close="handleClose" :parentId="parentId" @outboundSuccess="outboundSuccess" :xhName="xhName" :contractNum="contractNum"/>
  </div>
</template>
<script>
import { computed, defineComponent, onMounted, reactive, ref, getCurrentInstance } from '@vue/composition-api'
import PageWrapper from '@/components/PageWrapper/index.vue'
import waves from '@/directive/waves'
import request from '@/utils/request'
import Expand from './expand.vue'
import Outbound from './outbound.vue'

export default defineComponent({
  name:'outbound',
  components: { PageWrapper, Expand, Outbound },
  directives: { waves },
  setup({ emit }) {
    const instance = getCurrentInstance()
    const store = instance.proxy.$store.getters.name
    const searchFormRef = ref(null)

    const searchForm = reactive({
      xhname: '',
      company: '',
      orderid: '',
      gongyingshang: '',
      sfkp: '',
      sfsp: '',
      ow_type:'',
      username: store
    })
    const outboundDialog = ref(false)
    const showAll = ref(false)
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20
    })
    const allNum = ref(1)
    const dialog = ref(false)
    const type = ref('')
    const editFormData = ref({})
    const list = ref([])
    const exportLoading = ref(false)
    const tableRef = ref(false)
    const isShowOperationBtn = ref(false)

    const isInvoicing = ref([{ label: '已开', value: 1 }, { label: '未开', value: 0 }, { label: '未税', value: 2 }])
    const receiptStatus = ref([{ label: '已到', value: 1 }, { label: '未到', value: 2 }, { label: '未税', value: 0 }])
    const ckTypeStatus = ref([{label:'已出库',value: 'IsOutbound'},{label: '未出库',value: 'IsNotOutbound'},{label:'未完全出库',value:'IsPartiallyOutbound'}])
    const word = computed(() => {
      if (!showAll.value) {
        return '展开'
      } else {
        return '收起'
      }
    })

    const pageSizeChange = (e) => {
      selectPage.pageSize = e
      getOutbound()
    }

    const pageCurrentChange = (e) => {
      selectPage.pageNum = e
      isExpanded.value = false
      getOutbound()
    }

    const closeSearch = () => {
      showAll.value = !showAll.value
    }

    const handleSearchBtn = () => {
      selectPage.pageNum = 1
      getOutbound()
    }

    const handleResetBtn = () => {
      searchFormRef.value.resetFields()
      getOutbound()
    }

    const handleEdit = () => {
      dialog.value = true
      type.value = 'edit'
    }

    const isExpanded = ref(false)
    const toggleExpand = () => {
      isExpanded.value = !isExpanded.value
      list.value.forEach(row => {
        if (row.ck_type != 'F') {
          tableRef.value.toggleRowExpansion(row, isExpanded.value)
        }
      })
    }

    /**
     * 格式化数据为层级结构导出（支持中文表头）
     * @param {Array} mainHeaders 主列表中文表头
     * @param {Array} mainFields 主列表字段名
     * @param {Array} childHeaders 子列表中文表头
     * @param {Array} childFields 子列表字段名
     * @param {Object} fieldMappings 字段映射配置
     * @returns {Object} { headers, data } 包含表头和数据的对象
     */
    const formatJsonWithChineseHeaders = (resData,mainHeaders, mainFields, childHeaders, childFields, fieldMappings = {}) => {
      const newList = JSON.parse(JSON.stringify(resData));
      const data = [];

      // 合并表头（中文）
      const headers = [...mainHeaders, ...childHeaders];

      // 处理每条主记录
      newList.forEach(item => {
        // 应用字段映射到主记录
        applyFieldMappings(item, fieldMappings);

        // 添加主记录行 (主字段 + 子字段留空)
        const mainRow = mainFields.map(field => item[field] ?? "");
        const emptyChildCells = childFields.map(() => "");
        data.push([...mainRow, ...emptyChildCells]);

        // 处理子记录
        if (item.childdata?.length) {
          item.childdata.forEach(child => {
            // 应用字段映射到子记录
            applyFieldMappings(child, fieldMappings);

            // 添加子记录行 (主字段留空 + 子字段)
            const emptyMainCells = mainFields.map(() => "");
            const childRow = childFields.map(field => child[field] ?? "");
            data.push([...emptyMainCells, ...childRow]);
          });

          // 添加空行分隔
          data.push(Array(headers.length).fill(""));
        }
      });

      return { headers, data };
    };

// 应用字段映射的辅助函数
    const applyFieldMappings = (item, mappings) => {
      Object.entries(mappings).forEach(([key, mapper]) => {
        if (item[key] !== undefined) {
          item[key] = typeof mapper === 'function'
            ? mapper(item[key])
            : mapper[item[key]] ?? item[key];
        }
      });
    };


    const handleExport = () => {
      exportLoading.value = true;
      const { username, ...downLoadForm } = searchForm;

      request({
        url: 'out_wareh_download.yy',
        method: 'post',
        data: downLoadForm
      }).then(res => {
        if (res.code == 200) {
          import('@/vendor/Export2Excel').then(excel => {
            // 中文表头
            const mainHeaders = ['ID', '所属公司', '合同编号', '型号', '品牌','数量','单价','总价','采购状态'];
            const mainFields = ['id', 'company', 'orderid', 'xhname', 'source','num','price','zprice','ck_type'];

            const childHeaders = ['采购总价','采购渠道','采购数量','采购金额','是否含税','收票状态','采购时间'];
            const childFields = ['cgzprice', 'gongyingshang', 'number', 'cgprice', 'sfsp','sfkp','settime'];
            // 定义字段映射规则
            const fieldMappings = {
              // ck_type: {
              //   'T': '出库',
              //   'F': '未出库'
              // },
              // sfkp: value => value === 1? '已开' : value === 2 ? '未税':'未开',
              // sfsp: value => value === 1 ? '已到' : value === 2 ? '未到': '未税',
              // 可以添加更多映射规则
            };

            const { headers, data } = formatJsonWithChineseHeaders(
              res.data,
              mainHeaders, mainFields,
              childHeaders, childFields,
              fieldMappings
            );

            excel.export_json_to_excel({
              header: headers,
              data,
              filename: '进项报表',
              autoWidth: true,
            });
            exportLoading.value = false;
          });
        }
      });
    };

    const getOutbound = () => {
      request({
        url: 'out_wareh_list.yy',
        method: 'post',
        params: selectPage,
        data: searchForm
      }).then((res) => {
        if (res.code == 200) {
          list.value = res.data
          allNum.value = res.total
          if (res.qz_type === 'T') {
            isShowOperationBtn.value = true
          } else {
            isShowOperationBtn.value = false
          }
        }
      })
    }

    onMounted(() => {
      getOutbound()
    })
    const handleUpdateExpand = () => {
      getOutbound()
    }

    const handleDeleteRow = ({ parentId, childId }) => {
      const targetRow = list.value.find(row => row.id == parentId)
      if (targetRow) {
        targetRow.childdata = targetRow.childdata.filter(child => child.id !== childId)
      }
    }
    const parentId = ref(0)
    const xhName = ref('')
    const contractNum = ref(0)
    const handleOutbound = (name,id,num) => {
      outboundDialog.value = true
      parentId.value = id
      xhName.value  = name
      contractNum.value = num
    }

    const handleClose = () => {
      outboundDialog.value = false
    }

    //出库成功后，列表接口调用，刷新列表页面
    const outboundSuccess = (code) => {
      if(code == 200) {
        getOutbound()
        outboundDialog.value = false
      }
    }

    return {
      contractNum,
      xhName,
      parentId,
      outboundDialog,
      isShowOperationBtn,
      tableRef,
      searchFormRef,
      searchForm,
      showAll,
      dialog,
      editFormData,
      type,
      allNum,
      selectPage,
      word,
      list,
      isInvoicing,
      receiptStatus,
      isExpanded,
      exportLoading,
      ckTypeStatus,
      outboundSuccess,
      handleClose,
      handleDeleteRow,
      handleUpdateExpand,
      handleOutbound,
      pageSizeChange,
      pageCurrentChange,
      closeSearch,
      handleSearchBtn,
      handleResetBtn,
      handleEdit,
      toggleExpand,
      handleExport
    }
  }
})
</script>
<style scoped>
.el-icon-download {
  margin-bottom: 10px
}
.custom-table {
  width: 98.5%;
  margin: auto;
}
</style>
